// extracted by mini-css-extract-plugin
module.exports = {"vid-ctn":"html-player_vid-ctn__294OW","loader":"html-player_loader__pXZp3","spin":"html-player_spin__S7zqu","overlay":"html-player_overlay__2AkbG"};